import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-apple',
  standalone: true,
  templateUrl: '../../assets/apple.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamAppleIcon {}
